export default "__VITE_PUBLIC_ASSET__c5cbdd7c__"